<template>
  <div>
    <h3 class="mb-5">Description</h3>
    <div class="h4 mb-5">
      描述顯示於產品頁，若要新增描述欄數量，請點擊下方 [添加Description] 按鈕<br>
      需上傳 Preview Image 前台才可看到影片<br>
      [Xpg Product新版型說明如下]<br>
      僅Type5 & Type6支援影片<br>
      Type5~Type8 須至[Product Description KSP]建立底下的項目<br>
      ADATA 與 XPG 尺寸:<br />
      Type 1-6 1920 px X 800 px<br/>
      Type 7 350 px X 250 px<br/>
      Type 8 1200 px X 695 px<br/>
    </div>
    <!-- itemList -->
    <PageCollapse v-for="(item, i) in product.descriptions" :key="i">
      <template v-slot:head>
        <h3 class="mr-auto">Description {{ i + 1 }}</h3>
      </template>
      <template v-slot:actions>
        <div class="ml-auto">
          <button class="btn square mr-10px" @click="deleteItem(i)">
            <v-icon class="ink-02-medium--text">delete</v-icon>
          </button>
          <button class="btn square mr-10px" @click="downItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
          </button>
          <button class="btn square" @click="upItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
          </button>
        </div>
      </template>
      <template v-slot:body>
        <!-- banner type = Video -->
        <div>
          <!-- Section type -->
          <div class="form-item d-flex pb-5 mt-5 align-center"
              v-if="product.bu_id == 1 || product.bu_id == 2">
            <h4 class="w-180px mr-35px">Section Type</h4>
            <div class="flex-grow-1 mt-3">
              <v-radio-group v-model="item.section_type" row>
                <div
                  v-for="section_type in [
                    {
                      label: 'Type1-字壓圖(圖下)',
                      value: 1,
                    },
                    {
                      label: 'Type2-左右區塊(字左圖右)',
                      value: 2,
                    },
                    {
                      label: 'Type3-左右區塊(字右圖左)',
                      value: 3,
                    },
                    {
                      label: 'Type4-字壓圖(圖上)',
                      value: 4,
                    },
                    {
                      label: 'Type5-上下區塊(字上圖下)',
                      value: 5,
                    },
                    {
                      label: 'Type6-上下區塊(圖上字下)',
                      value: 6,
                    },
                    {
                      label: 'Type7-三欄式',
                      value: 7,
                    },
                    {
                      label: 'Type8-Disclaimer & Subfeature',
                      value: 8,
                    }
                  ]"
                  :key="section_type.value"
                  class="w-50"
                >
                  <v-radio class="mr-01" :value="section_type.value">
                    <template v-slot:label>
                      <div class="ink-01-emphasis--text w-202px">
                        {{ section_type.label }}
                      </div>
                    </template>
                  </v-radio>
                </div>
              </v-radio-group>
            </div>
          </div>
          <!-- Title -->
          <label class="form-item d-flex">
            <h4 class="w-180px my-5 mr-6">Title</h4>
            <div class="flex-grow-1 my-3">
              <v-text-field
                v-model="item.title"
                outlined
                dense
              ></v-text-field>
            </div>
          </label>
          <!-- Content -->
          <label class="form-item d-flex">
            <h4 class="w-180px my-5 mr-6">Content</h4>
            <div class="flex-grow-1 my-3">
              <editor
                :key="item.id"
                v-model="item.content"
                :plugins="'lists link'"
                :toolbar="'link bold bullist numlist'"
                :height="100"
              />
            </div>
          </label>
          <!-- 顯示/隱藏 -->
          <div class="form-item d-flex py-5">
            <div class="w-240px mr-5">
              <h4>顯示/隱藏</h4>
            </div>
            <div class="flex-grow-1 flex-basis-0">
              <FormSwitch v-model="item.status"></FormSwitch>
            </div>
          </div>
          <!-- 按鈕連結 -->
          <label class="form-item d-flex">
            <h4 class="w-180px my-5 mr-6">按鈕連結</h4>
            <div class="flex-grow-1 my-3">
              <v-text-field
                v-model="item.btn_url"
                outlined
                dense
              ></v-text-field>
            </div>
          </label>
          <!-- img upload -->
          <div class="d-flex px-5 pt-5 mb-8">
            <div class="w-180px">
              <h4 class="mb-10px">圖片</h4>
              <div class="h5 ink-02-medium--text">
                建議尺寸：999px * 999px <br />
                檔案大小限制：&lt; 1 MB
              </div>
            </div>
            <div class="d-flex justify-end flex-grow-1">
              <ImgUploader
                :imageUrl.sync="item.image"
                :dir="dir"></ImgUploader>
            </div>
          </div>
          <!-- upload type -->
          <div class="form-item d-flex pb-5 mt-5 align-center">
            <div class="w-180px">
              <h4 class="mb-10px">UploadType</h4>
              <div class="h5 ink-02-medium--text">
                [來自ADATA連結] 用來設定ADATA&XPG產品特效頁面(ex: 3D滑鼠特效…)
              </div>
            </div>
            <div class="flex-grow-1 mt-3">
              <v-radio-group v-model="item.upload_type" row>
                <div
                  v-for="uploadType in [
                    {
                      label: '自電腦上傳影片',
                      value: 'file',
                    },
                    {
                      label: '來自Youtube/Youku連結',
                      value: 'link',
                    },
                    {
                      label: '來自ADATA連結',
                      value: 'adata',
                    }
                  ]"
                  :key="uploadType.value"
                  class="w-50"
                >
                  <v-radio class="mr-01" :value="uploadType.value">
                    <template v-slot:label>
                      <div class="ink-01-emphasis--text w-202px">
                        {{ uploadType.label }}
                      </div>
                    </template>
                  </v-radio>
                </div>
              </v-radio-group>
            </div>
          </div>
        </div>
        <!-- banner type = Video, upload type = 自電腦上傳影片 -->
        <div v-if="item.upload_type == 'file'">
          <!-- 影片上傳 -->
          <div class="form-item d-flex px-5 pt-5 pb-5">
            <div class="w-200px">
              <h4 class="mb-10px">影片</h4>
              <div class="h5 ink-02-medium--text">
                影片支援格式：.mp4, .mov, .avi <br />
                檔案大小限制：&lt; 10 MB
              </div>
            </div>
            <div class="d-flex justify-end flex-grow-1">
              <FileUploader
                v-model="item.url"
                :dir="dir"></FileUploader>
            </div>
          </div>
        </div>

        <!-- banner type = Video, upload type = 來自Youtube/Youku or 3D產品特效連結 -->
        <div v-if="item.upload_type == 'link' || item.upload_type == 'adata'">
          <!-- Youtube -->
          <label class="form-item d-flex">
            <h4 class="w-180px my-5 mr-6">影片連結</h4>
            <div class="flex-grow-1 my-3">
              <div class="form-input-group">
                <div class="prepend-icon" style="top: 45%;">
                  <v-icon>link</v-icon>
                </div>
                <input
                  type="text"
                  class="pl-42px"
                  style="top: 45%"
                  v-model="item.url"
                />
              </div>
            </div>
          </label>
          <!-- Youku -->
          <!--<label class="form-item px-5 d-flex">-->
            <!--<h4 class="w-180px my-5 mr-6">Youku</h4>-->
            <!--<div class="flex-grow-1 my-3">-->
              <!--<div class="form-input-group">-->
                <!--<div class="prepend-icon" style="top: 45%;">-->
                  <!--<v-icon>link</v-icon>-->
                <!--</div>-->
                <!--<input type="text" class="pl-42px" v-model="item.youkuUrl" />-->
              <!--</div>-->
            <!--</div>-->
          <!--</label>-->
        </div>

        <!-- img upload -->
        <div class="d-flex px-5 pt-5 mb-8">
          <div class="w-180px">
            <h4 class="mb-10px">Preview Image</h4>
            <div class="h5 ink-02-medium--text">
              建議尺寸：999px * 999px <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="d-flex justify-end flex-grow-1">
            <ImgUploader
              :imageUrl.sync="item.preview_image"
              :dir="dir"></ImgUploader>
          </div>
        </div>
      </template>
    </PageCollapse>

    <!-- add team sponsorship -->
    <div class="mt-5">
      <button class="btn btn-outlined w-100 justify-start" @click="addItem">
        <v-icon class="primary--text mr-2">add_circle</v-icon>
        <span>添加Description</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ImgUploader from '@/components/ImgUploader.vue';
import PageCollapse from '@/components/PageCollapse.vue';
import FileUploader from '@/components/FileUploader.vue';
import Editor from '@/components/TinymceEditor.vue';
import FormSwitch from '@/components/FormSwitch.vue';

export default {
  props: {
    product: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    ImgUploader,
    PageCollapse,
    FileUploader,
    Editor,
    FormSwitch,
  },
  data: () => ({
    dir: 'product',
  }),
  methods: {
    ...mapActions({
      upload: 'upload',
    }),
    addItem() {
      const template = {
        id: null,
        // video
        upload_type: 'file',
        section_type: 0,
        title: '',
        content: '',
        url: '',
        image: '',
        preview_image: '',
        status: true,
      };
      this.product.descriptions.push(template);
    },
    deleteItem(index) {
      this.product.descriptions.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.product.descriptions.length - 1) {
        this.product.descriptions.splice(i, 1);
        this.product.descriptions.unshift(item);
        return;
      }
      // item become next index
      this.product.descriptions.splice(i, 1);
      this.product.descriptions.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.product.descriptions.splice(i, 1);
        this.product.descriptions.push(item);
        return;
      }
      // item become previous index
      this.product.descriptions.splice(i, 1);
      this.product.descriptions.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
